import { BaseRouteService } from 'core/services';

class FulfillmentChannelOrderRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'fulfillment-channel-orders/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	exportToCsv(filter) {
		return super.create(this.base + 'export', filter);
	}
}

export default FulfillmentChannelOrderRouteService;
